// Screenname:hsn master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class Hsnservices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/HSNMAS/Create", doc);
  }
  getdata(HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/HSNMAS/List?HospitalId=" + HospitalId
    );
  }
  getfindonedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/HSNMAS/Get?id=" + doc + "&HospitalId=" + HospitalId
    );
  }
  updatedata(doc) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.post("/HSNMAS/Update", doc);
  }
  deletedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.delete("/HSNMAS/Delete?id=" + doc + "&HospitalId=" + HospitalId);
  }
  active(doc, Status, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.put(
      "/HSNMAS/Active?id=" + doc + "&Status=" + Status + "&HospitalId=" + HospitalId
    );
  }
  getHsnNameAutocomplete(Hsncode, Type, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/HSNMAS/GetHsnNameAutocomplete?Hsncode=" +
      Hsncode +
      "&Type=" +
      Type +
      "&HospitalId=" +
      HospitalId +
      ""
    );
  }
}
export default new Hsnservices();
